import React,{useState,useEffect} from "react";
import { Trans, useTranslation} from 'react-i18next'
import Select from 'react-select'

function NotificationSettings({toogleOption,toogleTaskbar}){
        const NotificationOptions = [{ value: 'Yes', label: 'Yes' },{ value: 'No', label: 'No' }]
        const [Notifications,setNotifications] = useState()
        const {t, i18n } = useTranslation();

        const changeNotificationHandler = value =>{
            setNotifications(value)
        }

        const colourStyles = {
            control: styles => ({ ...styles,  borderColor: '#636468',
            backgroundColor:'rgba(0,0,0,16%)',
            width: '29.75em',
            height: '3em',
            borderRadius:'8px',
            color:'rgba(255, 255, 255, 1)',
            marginTop:'0.8em'
           }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                backgroundColor:'#18191F' ,
                color:'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop:'-0.3em',
                marginBottom:'-0.3em'
              };
            },
            input: (styles) => ( {...styles , 
                                    FontFamily:'ClashGrotesk-Variable,sans-serif',
                                    FontSize:'1rem',
                                    FontWeight: 'medium',
                                    LineHeight: '150%',
                                    LetterSpacing: '0%',
                                    color:'rgba(255, 255, 255, 1)'}),
            singleValue : (styles) => ({ ...styles, 
                                            color:'rgba(255, 255, 255, 1)',
                                            FontFamily:'ClashGrotesk-Variable,sans-serif',
                                            FontSize:'1rem',
                                            FontWeight: 'medium',
                                            LineHeight: '150%',
                                            LetterSpacing: '0%'})
          };

        useEffect(()=>{
            toogleOption(5)
        },[])


        return (
            <div style={{display:'flex',flexDirection:'column',paddingBottom:'2.5em',paddingRight:'2em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
            <div className="MembershipTxt">{t('Notificationsettings')}</div>
            <div className="ProfileSettingHeader" style={{marginLeft:'5.5em',marginTop:'2em'}}>
            <Trans i18nKey="Wouldyouliketoreceive" components={{1:<br/>}} >
            Would you like to receive email notifications about your<br/> account events and updates?
            </Trans></div>
                <div style={{marginLeft:'4.8em',maxWidth:'29.75em'}}>
                    <Select options={NotificationOptions} value={Notifications} onChange={changeNotificationHandler} 
                        components={{
                        IndicatorSeparator: () => null
                        }}
                        styles={
                        colourStyles
                        }
                        />
                </div>

                <div className="UpdateBtn">
                {t('Update')}
                <div className="PostLoginBtnOverlay" style={{left:'0em'}}/>
                </div>
                        
        </div>
        )
}

export default NotificationSettings;